module.exports = (pageId, componentQueries, preview, limit) => `query{
    page(id: "${pageId}",preview:${preview}){
        sys{id} seoHead{breadcrumbsTitle    title   description url ogTitle ogType  ogDescription   ogImage{url width   height    contentType}
            canonicals: canonicalLinksCollection (limit: 6,preview:${preview}){items{canonical}}}
        contentCollection(limit: ${limit},preview:${preview}){    items{  __typename  ${componentQueries}}}   classname}}`;
